import { backendClient } from "../../api/backend";
import { backendUrl } from "../../config";
import {
  CREATE_CONVERSATION_FAILURE,
  CREATE_CONVERSATION_REQUEST,
  CREATE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION,
  FETCH_CONVERSATION_FAILURE,
  FETCH_CONVERSATION_REQUEST,
  FETCH_CONVERSATION_SUCCESS,
  FETCH_CONVERSATIONS_FAILURE,
  FETCH_CONVERSATIONS_REQUEST,
  FETCH_CONVERSATIONS_SUCCESS,
  SEARCH_CONVERSATIONS_FAILURE,
  SEARCH_CONVERSATIONS_REQUEST,
  SEARCH_CONVERSATIONS_SUCCESS,
  SET_CONVERSATION,
  SET_MESSAGES,
  SHARE_CONVERSATION_SUCCESS,
  SYSTEM_SEND_MESSAGE,
  USER_SEND_MESSAGE,
  UPDATE_CONVERSATION_TITLE,
  UPDATE_MESSAGE_LIKE,
  UPDATE_MESSAGE_CONTENT,
  RESET_CONVERSATION,
  FETCH_FILTERED_CONVERSATIONS_REQUEST,
  FETCH_FILTERED_CONVERSATIONS_SUCCESS,
  FETCH_FILTERED_CONVERSATIONS_FAILURE,
  SET_MESSAGE_LOADING,
  SET_STREAMING_MESSAGE_ID,
  UPDATE_MESSAGE_SOURCES,
  UPDATE_MESSAGE_TOOLS,
  ADD_TOOL_EXECUTION,
  SET_MESSAGE_ERROR,
  SET_PENDING_FILES,
  CLEAR_PENDING_FILES,
  UPDATE_MESSAGE_NODE_EXECUTION,
  UPDATE_MESSAGE_PLAN,
  UPDATE_MESSAGE_STEP_EXECUTION,
  UPDATE_MESSAGE_METADATA,
  UPDATE_MESSAGE_ARTIFACTS,
  SET_DOCUMENT_PROCESSING_STATUS,
  CLEAR_DOCUMENT_PROCESSING_STATUS,
} from "./types";
import { EventSourcePolyfill } from "event-source-polyfill";
import { v4 as uuidv4 } from "uuid";


export const updateMessageContent = (conversationId, messageId, content) => {
  return async (dispatch) => {
    try {
      await backendClient.updateMessage(conversationId, messageId, content);
      dispatch({
        type: UPDATE_MESSAGE_CONTENT,
        payload: { messageId, content },
      });
    } catch (error) {
      console.error('Failed to update message:', error);
      // Optionally handle errors, e.g., show an error message to the user
    }
  };
};

export const resetConversation = () => async (dispatch) => {
  dispatch({ type: RESET_CONVERSATION })
}

export const fetchConversations =
  (user_id, limit = 5, offset = 0, { silent = false } = {}) =>
    async (dispatch) => {
      // Only show loading state for initial load, not for "load more" or silent refresh
      if (offset === 0 && !silent) {
        dispatch({ type: FETCH_CONVERSATIONS_REQUEST });
      }

      try {
        const data = await backendClient.fetchUserConversations(
          user_id,
          limit,
          offset
        );
        dispatch({
          type: FETCH_CONVERSATIONS_SUCCESS,
          payload: {
            data,
            isLoadMore: offset > 0, // True if loading more (offset > 0), false if initial load
          },
        });
        return data; // Return data for handleLoadMore to check length
      } catch (error) {
        console.error(
          `Erreur lors de la récupération des conversations : ${error.message}`
        );
        dispatch({
          type: FETCH_CONVERSATIONS_FAILURE,
          error: `Échec de la récupération des conversations : ${error.message}`,
        });
      }
    };

export const createConversationRequest = () => ({
  type: CREATE_CONVERSATION_REQUEST,
});

export const createConversationSuccess = (conversation) => ({
  type: CREATE_CONVERSATION_SUCCESS,
  payload: conversation,
});

export const createConversationFailure = (error) => ({
  type: CREATE_CONVERSATION_FAILURE,
  payload: error,
});

export const createConversation = (userId) => {
  return async (dispatch) => {
    dispatch(createConversationRequest()); // Dispatch the request action

    try {
      // const conversation = await backendClient.createConversation(userId); // Call the API
      const conversation = {
        id: uuidv4(),
        users_ids: userId ? [userId] : [],
        messages: [],
        conversation_documents: [],
        title: "",
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };

      dispatch(createConversationSuccess(conversation)); // Dispatch success with conversation object
      return conversation;
    } catch (error) {
      // Dispatch failure with error message
      const errorMessage =
        error.message ||
        "Échec de la création de la conversation. Veuillez réessayer.";
      dispatch(createConversationFailure(errorMessage));
    }
  };
};

export const deleteConversations =
  (conversationIds, userId) => async (dispatch) => {
    try {
      console.log("DELETE conversationIds, userId", conversationIds, userId);
      await backendClient.deleteConversations(conversationIds); // Backend call
      dispatch({
        type: DELETE_CONVERSATION,
        payload: conversationIds, // Pass the conversation IDs to be deleted
      });
    } catch (error) {
      console.error("Failed to delete conversations:", error);
    }
  };

export const fetchConversationRequest = () => ({
  type: FETCH_CONVERSATION_REQUEST,
});

export const fetchConversationSuccess = (conversation) => ({
  type: FETCH_CONVERSATION_SUCCESS,
  payload: conversation,
});

export const fetchConversationFailure = (error) => ({
  type: FETCH_CONVERSATION_FAILURE,
  payload: error,
});

export const updateMessageLike = (message_id, value) => {
  return async (dispatch, getState) => {
    try {
      // Call the backend to update the like field
      console.log("updating like", message_id, value);
      await backendClient.updateMessageLike(message_id, value);

      // Dispatch the update to Redux store
      dispatch({
        type: UPDATE_MESSAGE_LIKE,
        payload: { message_id, value },
      });
    } catch (error) {
      console.error("Failed to update message like:", error);
      // Optionally handle errors, e.g., show an error message to the user
    }
  };
};

export const fetchConversation = (conversationId) => async (dispatch) => {
  dispatch(fetchConversationRequest());
  try {
    const result = await backendClient.fetchConversation(conversationId);
    if (result?.messages) {
      dispatch(setMessages(result.messages));
    }
    // Set the full conversation object, not just documents
    dispatch(setConversation(result));
    dispatch(fetchConversationSuccess(result));
    return result;
  } catch (error) {
    console.error("Error fetching conversation:", error);
    dispatch(fetchConversationFailure(error.message));
  }
};

export const setConversation = (conversation) => ({
  type: SET_CONVERSATION,
  payload: conversation,
});

export const setMessages = (messages) => ({
  type: SET_MESSAGES,
  payload: messages,
});

export const userSendMessage = (content) => ({
  type: USER_SEND_MESSAGE,
  payload: content,
});

export const systemSendMessage = (message) => ({
  type: SYSTEM_SEND_MESSAGE,
  payload: message,
});

// SSE and loading action creators
export const setMessageLoading = (isLoading) => ({
  type: SET_MESSAGE_LOADING,
  payload: isLoading,
});

export const setStreamingMessageId = (messageId) => ({
  type: SET_STREAMING_MESSAGE_ID,
  payload: messageId,
});

export const updateMessageSources = (messageId, sources) => ({
  type: UPDATE_MESSAGE_SOURCES,
  payload: { messageId, sources },
});

export const updateMessageTools = (messageId, toolData) => ({
  type: UPDATE_MESSAGE_TOOLS,
  payload: { messageId, ...toolData },
});

export const addToolExecution = (messageId, toolExecution) => ({
  type: ADD_TOOL_EXECUTION,
  payload: { messageId, toolExecution },
});

export const setMessageError = (messageId, error) => ({
  type: SET_MESSAGE_ERROR,
  payload: { messageId, error },
});

export const setPendingFiles = (files) => ({
  type: SET_PENDING_FILES,
  payload: files,
});

export const clearPendingFiles = () => ({
  type: CLEAR_PENDING_FILES,
});

export const setDocumentProcessingStatus = (status) => ({
  type: SET_DOCUMENT_PROCESSING_STATUS,
  payload: status,
});

export const clearDocumentProcessingStatus = () => ({
  type: CLEAR_DOCUMENT_PROCESSING_STATUS,
});

// Agentic pipeline action creators
export const updateMessageNodeExecution = (messageId, node_executions) => ({
  type: UPDATE_MESSAGE_NODE_EXECUTION,
  payload: { messageId, node_executions },
});

export const updateMessagePlan = (messageId, execution_plan) => ({
  type: UPDATE_MESSAGE_PLAN,
  payload: { messageId, execution_plan },
});

export const updateMessageStepExecution = (messageId, step_id, updates) => ({
  type: UPDATE_MESSAGE_STEP_EXECUTION,
  payload: { messageId, step_id, updates },
});

export const updateMessageMetadata = (messageId, metadata) => ({
  type: UPDATE_MESSAGE_METADATA,
  payload: { messageId, metadata },
});

export const updateMessageArtifacts = (messageId, artifacts) => ({
  type: UPDATE_MESSAGE_ARTIFACTS,
  payload: { messageId, artifacts },
});

// Thunk to submit a new message
export const submitMessage =
  (conversationId, userMessage) => async (dispatch) => {
    const tokenPayload = backendClient.getToken();
    if (!tokenPayload) {
      console.error("No authentication token available.");
      return;
    }

    await dispatch(userSendMessage(userMessage));

    const token = `${tokenPayload.token_type
      .charAt(0)
      .toUpperCase()}${tokenPayload.token_type.slice(1)} ${encodeURIComponent(
        tokenPayload.access_token
      )}`;
    const encodedUserMessage = encodeURIComponent(userMessage);
    const messageEndpoint = `${backendUrl}api/conversation/${conversationId}/message?user_message=${encodedUserMessage}`;

    const events = new EventSourcePolyfill(messageEndpoint, {
      headers: {
        Authorization: token,
      },
    });

    // console.log('eventsXX', events)
    // console.log('messageEndpointXX', messageEndpoint)
    // console.log('tokenXXX', token)

    // events.onmessage = (event) => {
    //   const parsedData = JSON.parse(event.data);
    //   console.log('parsedDataXX', parsedData)
    //   dispatch(systemSendMessage(parsedData));

    //   if (parsedData.status === MESSAGE_STATUS.SUCCESS || parsedData.status === MESSAGE_STATUS.ERROR) {
    //     events.close();
    //   }
    // };

    // events.onerror = (event) => {
    //   console.error("EventSource failed:", event);
    //   events.close();
    // };
  };

// Action creators
export const searchConversationsRequest = () => ({
  type: SEARCH_CONVERSATIONS_REQUEST,
});

export const searchConversationsSuccess = (conversations) => ({
  type: SEARCH_CONVERSATIONS_SUCCESS,
  payload: conversations,
});

export const searchConversationsFailure = (error) => ({
  type: SEARCH_CONVERSATIONS_FAILURE,
  payload: error,
});

// Search Conversations function
export const searchConversations = (userId, searchTerm) => {
  return async (dispatch) => {
    dispatch(searchConversationsRequest());
    try {
      const response = await backendClient.searchUserConversations(
        userId,
        searchTerm
      );
      const data = await response.json();
      dispatch(searchConversationsSuccess(data));
    } catch (error) {
      dispatch(searchConversationsFailure(error.message));
    }
  };
};

export const shareConversation =
  (conversationId, userIds, userDomain) => async (dispatch) => {
    try {
      const result = await backendClient.shareConversation(
        conversationId,
        userIds,
        userDomain
      );

      if (result.ok) {
        dispatch({ type: SHARE_CONVERSATION_SUCCESS, payload: conversationId });
      }
    } catch (error) {
      console.error(`Failed to share conversation: ${error.message}`);
    }
  };


export const filterConversations = (filterParams, userId, limit = 10, offset = 0) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_FILTERED_CONVERSATIONS_REQUEST });

    try {
      // Extract filter parameters from the filterParams object
      const activeFilters = filterParams || [];
      let query = {};

      // Add date filters
      if (activeFilters.includes('thisWeek')) {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
        query.updated_after = oneWeekAgo.toISOString();
      } else if (activeFilters.includes('thisMonth')) {
        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
        query.updated_after = oneMonthAgo.toISOString();
      }

      // Add user count filter
      if (activeFilters.includes('multipleUsers')) {
        query.min_users = 2;
      }

      // Prepare the request body
      const requestBody = {
        filter_params: query,
        user_id: userId,
        limit,
        offset
      };

      // Call the backend API
      const response = await backendClient.post('api/conversation/filter', requestBody);

      if (!response.ok) {
        throw new Error(`Failed to filter conversations: HTTP status ${response.status}`);
      }

      const data = await response.json();

      dispatch({
        type: FETCH_FILTERED_CONVERSATIONS_SUCCESS,
        payload: data
      });

      return data;
    } catch (error) {
      console.error(`Error filtering conversations: ${error.message}`);
      dispatch({
        type: FETCH_FILTERED_CONVERSATIONS_FAILURE,
        payload: `Failed to filter conversations: ${error.message}`      });
      throw error;
    }
  };
};

export const updateConversationTitleInStore = (conversationId, title) => ({
  type: UPDATE_CONVERSATION_TITLE,
  payload: { conversationId, title },
});

export const updateConversationTitle = (conversationId, title) => async (dispatch) => {
  try {
    await fetch(`${backendUrl}api/chat/conversations/${conversationId}/title`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title }),
    });
    dispatch(updateConversationTitleInStore(conversationId, title));
  } catch (error) {
    console.error('Failed to update conversation title:', error);
  }
};
